var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-date-input",class:( _obj = {
		'is-filled': _vm.isFilled,
		'has-error': _vm.hasError,
		'is-required': _vm.$attrs.required !== undefined && _vm.$attrs.required !== 'false'
	}, _obj[_vm.dynamicClass] = _vm.dynamicClass, _obj )},[(_vm.label)?_c('label',{ref:"fieldLabel",staticClass:"c-form-label",class:{
			'c-form-label--long': _vm.labelLong
		},attrs:{"for":_vm.inputId}},[_vm._v("\n\t\t"+_vm._s(_vm.label)+"\n\t")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({ref:"input",tag:"component",staticClass:"c-date-input__input fs-copy-bold",attrs:{"type":'date',"id":_vm.inputId,"name":_vm.name,"value":_vm.value},on:{"input":_vm.onInput,"focus":function (event) { return _vm.$emit('focus', event); },"invalid":function($event){$event.preventDefault();return _vm.$emit('invalid', $event)}}},'component',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }